import { Link } from 'react-router-dom';
import { bigDealDays2026Cover } from '../covers';

/** Event facts come only from Amazon's own Prime Big Deal Days 2026 announcement (Associates Agreement: no inaccurate or misleading promotion claims). */
export default function PrimeBigDealDays2026(): JSX.Element {
    return (
        <div className="postContainer">
        <article className="post">
            <h1>Prime Big Deal Days 2026 Starts Tomorrow: What to Know</h1>
            <span className="postPublish">Published on October 5th, 2026</span>

            <img className="postCover" src={ bigDealDays2026Cover.src } alt={ bigDealDays2026Cover.alt } />

            <p>Amazon has announced that Prime Big Deal Days returns on October 6 and 7, 2026. The 48-hour event is open to
                Prime members in 22 countries, including the US. Here is what Amazon has shared about the event, plus a few
                tips from our team to help you get ready.</p>

            <h3>When It Runs</h3>
            <ul>
                <li><b>Starts:</b> Tuesday, October 6, at 12:01 a.m. PDT</li>
                <li><b>Runs:</b> 48 hours, through Wednesday, October 7</li>
            </ul>

            <h3>Who Can Shop</h3>
            <p>Prime Big Deal Days is for Prime members. Amazon says eligible customers who are not members yet can start a
                free 30-day Prime trial to shop the event.</p>

            <h3>Today's Big Deals</h3>
            <p>According to Amazon, new "Today's Big Deals" drop three times a day during the event: at midnight, 8 a.m.,
                and 1 p.m. PDT. If there is something specific you are waiting for, check back after each drop.</p>

            <h3>What's Included</h3>
            <p>Amazon says the event covers more than 35 categories, and early deals are already available ahead of the
                event.</p>

            <h3>Deal Alerts</h3>
            <p>Amazon also says Alexa for Shopping can send deal alerts and track prices on items you are watching.</p>

            <h3>Tips From Our Team</h3>
            <ul>
                <li>Make a list of what you actually need before the event starts, so you are not shopping on impulse.</li>
                <li>Note what you would normally pay for those items, so you can tell a real deal when you see one.</li>
                <li>Set reminders for the three daily drop times if you are watching for something specific.</li>
                <li>Check our <Link to="/deals" className="linkText">deals page</Link> for deals our team finds, and our <Link
                    to="/tips" className="linkText">tips page</Link> for more ways to save.</li>
            </ul>

            <div className="postCta">
                <Link to="/deals" className="btn btn-primary">Shop our latest finds</Link>
            </div>

            <p className="postPublish">Event details are from <a className="linkText"
                href="https://press.aboutamazon.com/2026/9/prime-big-deal-days-is-back-october-6-7-kicking-off-the-season-with-two-days-of-exclusive-savings-for-prime-members">Amazon's
                Prime Big Deal Days 2026 announcement</a>.</p>

            <p>Happy shopping!</p>
        </article>
        </div>
    );
}
